import React from 'react';
import './SuiteHeader.scss';
import Tenant from '../../../components/Tenant';
import Avatar from '../../../components/Avatar';
import Skeleton from 'src/components/Skeleton/Skeleton';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { Colors } from 'src/Tenants';
import { onRequestPhoneCall } from '../../../helpers/validationHelper';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';

export const Headline = ({
  suiteName = '',
  showProfile,
  profileLinkTo,
  disableLink,
  name,
  phone,
  image,
  isCommonArea = false,
  loading = false,
}: any) => {
  if (loading) {
    return (
      <div className="suite-header__container">
        <div className="suite-header__title">
          <h1><Skeleton variant="text" width="14rem" /></h1>
        </div>
        <div className="suite-header__user">
          <Tenant left loading />
        </div>
      </div>
    );
  }

  return (
    <div className="suite-header__container">
      <div className="suite-header__title">
        <h1>{suiteName}</h1>
        {isCommonArea && (
          <CategoryPill
            text="Common Area"
            size="small"
            color={Colors.toggleAndButtonColor}
          />
        )}
      </div>
      {showProfile && (
        <div className="suite-header__user">
          <LinkWrapper to={profileLinkTo ?? {}} disabled={disableLink}>
            <Tenant
              left
              headline={name}
              strapline={onRequestPhoneCall(phone)}
              avatar={<Avatar url={image} />}
            />
          </LinkWrapper>
        </div>
      )}
    </div>
  );
};

const LinkWrapper = ({ to, disabled, children }) => {
  const authenticatedUser: any = useSelector(selectAuthenticatedUser);
  const userRole: any = authenticatedUser.roles[0]?.role?.name;

  if (!to || disabled || userRole === 'Home Owner') {
    return children;
  }

  return <Link to={to}>{children}</Link>;
};
